import Link from './Link';
export default Link;
//# sourceMappingURL=index.js.map